import { useEffect, useState } from 'react';
import { api } from './api';

// Le a flag "Pode incluir descrição na imagem" (Configuração da empresa).
// Fetch próprio e leve — não existe (ainda) um contexto global de configuração
// da empresa nesta base, então cada tela que precisa dessa flag busca a sua.
export function usePodeIncluirDescricaoImagem(): boolean {
  const [pode, setPode] = useState(false);

  useEffect(() => {
    let ativo = true;
    api<{ os_pode_incluir_descricao_imagem?: boolean | string | number }>('/config_empresa/configuracoes.php')
      .then((cfg) => {
        if (!ativo) return;
        const v = cfg.os_pode_incluir_descricao_imagem;
        setPode(v === true || v === 'true' || v === 1 || v === '1');
      })
      .catch(() => { if (ativo) setPode(false); });
    return () => { ativo = false; };
  }, []);

  return pode;
}
